<template>
  <div class="footer">
    <div class="footer-upper">
      <div class="footer-upper-content">
        <div class="chartwatchers-background"></div>
        <div class="chartwatchers-description">
          <h4 class="chartwatchers-description-heading">Expert market commentary delivered right to your inbox, <span>for free.</span></h4>
          <p class="chartwatchers-description-content">Sign up for our weekly ChartWatchers Newsletter</p>
        </div>
        <div class="chartwatchers-signup">
          <div class="chartwatchers-signup-inner">
            <form
              action="https://stockcharts.us17.list-manage.com/subscribe/post?u=3353671ea8af8c5eab80183ab&amp;id=7b214beb69"
              method="post"
              name="mc-embedded-subscribe-form"
              class="chartwatchers-signup-form"
              target="_blank"
              rel="noopener noreferrer"
              novalidate
            >
              <div class="chartwatchers-signup-form-email-container">
                <input
                  type="email"
                  value=""
                  name="EMAIL"
                  placeholder="Enter Your Email"
                  class="chartwatchers-signup-form-email"
                  id="mce-EMAIL"
                  aria-label="Enter Your Email"
                />
              </div>
              <div class="chartwatchers-signup-form-submit-button-container">
                <input
                  type="submit"
                  value="Sign Up"
                  name="subscribe"
                  id="mc-embedded-subscribe"
                  class="chartwatchers-signup-form-submit-button"
                />
              </div>
              <div class="chartwatchers-signup-form-success-and-error-messages-container">
                <div class="chartwatchers-signup-form-success-message"></div>
                <div class="chartwatchers-signup-form-error-message"></div>
              </div>
              <div class="chartwatchers-signup-form-bot-signup" aria-hidden="true"><input type="text" name="b_3353671ea8af8c5eab80183ab_7b214beb69" tabindex="-1" value="" aria-label="Sign Up" /></div>
            </form>
          </div>
          <div class="chartwatchers-signup-learn-more-link-container">
            <a class="chartwatchers-signup-learn-more-link" href="/newsletter/">Learn&nbsp;More&nbsp;&nbsp;<i class="fas fa-fw fa-arrow-circle-right"></i></a>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-lower">
      <div class="footer-lower-content">
        <div class="site-links">
          <div class="site-link-group">
            <h4>On&nbsp;StockCharts</h4>
            <ul class="list-unstyled">
              <li><a href="/freecharts/">Charts &amp; Tools</a></li>
              <li><a href="/articles/">Articles</a></li>
              <li><a href="/tv/">StockCharts TV</a></li>
              <li><a href="//chartschool.stockcharts.com" rel="noopener noreferrer">ChartSchool</a></li>
            </ul>
          </div>
          <div class="site-link-group">
            <h4>Members</h4>
            <ul class="list-unstyled">
              <li><a href="/panels">Your Dashboard</a></li>
              <li><a href="/def/servlet/Favorites.CServlet#chartlists">Your ChartLists</a></li>
              <li><a href="/def/servlet/ScanUI">Advanced Scans</a></li>
              <li><a href="/h-mem/useralertsummary.html">Technical Alerts</a></li>
            </ul>
          </div>
          <div class="site-link-group">
            <h4>Help</h4>
            <ul class="list-unstyled">
              <li><a href="//help.stockcharts.com" rel="noopener noreferrer">Support Center</a></li>
              <li><a href="//help.stockcharts.com/learning-more/frequently-asked-questions" rel="noopener noreferrer">FAQs</a></li>
              <li><a href="/support/techsupport.html">Contact Us</a></li>
              <li><a href="/freecharts/catalog/">Symbol Catalog</a></li>
              <li><a href="/pricing/">Pricing</a></li>
            </ul>
          </div>
          <div class="site-link-group">
            <h4>Company</h4>
            <ul class="list-unstyled">
              <li><a href="/about/">About Us</a></li>
              <li><a href="/press/">Press</a></li>
              <li><a href="/careers/">Careers</a></li>
            </ul>
          </div>
        </div>
        <div class="logo-column">
          <a class="logo-link" href="/" title="StockCharts.com">
            <img src="//d.stockcharts.com/img/scc-logo-light.png" alt="StockCharts.com Logo" class="footer-logo" />
          </a>
          <ul class="social-links list-inline list-unstyled">
            <li><a href="https://www.facebook.com/stockchartsdotcom" target="_blank" aria-label="StockCharts Facebook Page" title="Facebook" rel="noopener noreferrer"><i class="fab fa-fw fa-facebook-f"></i></a></li>
            <li><a href="https://twitter.com/stockcharts" target="_blank" aria-label="StockCharts Twitter Page" title="Twitter" rel="noopener noreferrer"><i class="fab fa-fw fa-twitter"></i></a></li>
            <li><a href="https://www.youtube.com/user/stockchartscom" target="_blank" aria-label="StockCharts YouTube Page" title="YouTube" rel="noopener noreferrer"><i class="fab fa-fw fa-youtube"></i></a></li>
            <li><a href="https://www.linkedin.com/company/stockcharts.com-inc." target="_blank" aria-label="StockCharts LinkedIn Page" title="LinkedIn" rel="noopener noreferrer"><i class="fab fa-fw fa-linkedin-in"></i></a></li>
          </ul>
        </div>
        <div class="copyright-and-mobile-app-buttons-column">
          <div class="mobile-app-buttons">
            <a href="/ios-app/" title="App Store" target="_blank" class="mobile-app-button-for-larger-screen-widths">
              <img src="//d.stockcharts.com/img/app-store-btn.png" alt="Download StockCharts On The App Store">
            </a>
            <a href="https://apps.apple.com/us/app/stockcharts/id6443663518" title="App Store" target="_blank" rel="noopener noreferrer" class="mobile-app-button-for-smaller-screen-widths">
              <img src="//d.stockcharts.com/img/app-store-btn.png" alt="Download StockCharts On The App Store">
            </a>
            <a href="/android-app/" title="Google Play Store" target="_blank" class="mobile-app-button-for-larger-screen-widths">
              <img src="//d.stockcharts.com/img/google-play-btn.png" alt="Download StockCharts On The Google Play Store" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.stockcharts.mobile.app.android" title="Google Play Store" target="_blank" rel="noopener noreferrer" class="mobile-app-button-for-smaller-screen-widths">
              <img src="//d.stockcharts.com/img/google-play-btn.png" alt="Download StockCharts On The Google Play Store" />
            </a>
          </div>
          <div class="copyright-content">
            <p class="copyright">&copy;&nbsp;StockCharts.com,&nbsp;Inc. All&nbsp;Rights&nbsp;Reserved.</p>
            <ul class="copyright-links list-inline list-unstyled">
              <li><a href="//help.stockcharts.com/learning-more/policies-and-limitations/terms-of-service" target="_blank" rel="noopener noreferrer">Terms&nbsp;of&nbsp;Service</a></li>
              <li><a href="//help.stockcharts.com/learning-more/policies-and-limitations/privacy-statement" target="_blank" rel="noopener noreferrer">Privacy&nbsp;Statement</a></li>
              <li><a href="/sitemap.html" target="_blank">Site&nbsp;Map</a></li>
            </ul>
          </div>
        </div>
        <div class="legal-column">
          <p>Market data provided by <b>Xignite, Inc</b>. Commodity and historical index data provided by
            <b>Pinnacle Data Corporation</b>. Cryptocurrency data provided by <b>CryptoCompare</b>. Unless otherwise indicated,
            all data is delayed by 15 minutes. The information provided by StockCharts.com, Inc. is not investment advice.
            Trading and investing in financial markets involves risk. You are responsible for your own
            investment&nbsp;decisions.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .footer {
    text-align: left;
    line-height: 1.42857143;
  }

  .footer-upper {
    background-color: #133353;
    padding: 20px 0px 15px 0px;
    position: relative;
    overflow: hidden;
  }

  .footer-lower {
    background-color: #0e263e;
    padding: 15px 0px;
  }

  .footer-upper-content {
    padding: 0px 15px;
    margin: 0px auto;
  }

  .chartwatchers-background {
    position: absolute;
    top: -15%;
    bottom: 0px;
    left: 0px;
    right: 0px;
    background: url(//d.stockcharts.com/img/chartwatchers/cw-logo-icon.png) no-repeat center center scroll;
    background-size: contain;
    opacity: 0.1;
    width: 35%;
    height: 130%;
  }

  .chartwatchers-description {
    min-height: 1px;
    padding-right: 15px;
    padding-left: 15px;
  }

  .chartwatchers-description-heading {
    max-width: 450px;
    margin: 0px 0px 10px 0px;
    line-height: 1.35;
    font-size: 25px;
    font-weight: 900;
    color: white;
  }

  .chartwatchers-description-heading span {
    color: #f8d23a;
  }

  .chartwatchers-description-content {
    margin: 0px;
    font-size: 18px;
    font-weight: bold;
    color: #dfe7ec;
    line-height: 1.42857143;
  }

  .chartwatchers-signup {
    padding: 20px 15px 0px 15px;
    position: relative;
    min-height: 1px;
  }

  .chartwatchers-signup-inner {
    margin-bottom: 15px;
  }

  .chartwatchers-signup-form-email-container {
    display: inline-block;
    vertical-align: middle;
    width: calc(100% - 110px);
    margin: 0px 7px 0px 0px;
  }

  .chartwatchers-signup-form-email {
    height: 50px;
    font-size: 18px;
    padding: 10px;
    margin: 0px;
    appearance: none;
    border: 2px solid #c0ced8;
    border-radius: 5px;
    font-weight: 700;
    color: #707f8f;
    text-overflow: ellipsis;
    transition: all 0.35s ease;
    line-height: 1.3333333;
    display: block;
    width: 100%;
    background-color: white;
  }

  .chartwatchers-signup-form-email:hover,
  .chartwatchers-signup-form-email:active,
  .chartwatchers-signup-form-email:focus {
    border-color: #707f8f;
    color: #2d3339;
  }

  .chartwatchers-signup-form-email::placeholder {
    color: #999;
  }

  .chartwatchers-signup-form-submit-button-container {
    display: inline-block;
    vertical-align: middle;
    margin: 0px auto;
  }

  .chartwatchers-signup-form-submit-button {
    height: unset;
    border-radius: 5px;
    margin: 0px;
    padding: 12px 20px;
    font-size: 16px;
    background-color: #219155;
    border: 2px solid #219155;
    display: inline-block;
    transition: all 0.35s ease;
    font-weight: 700;
    color: white;
    appearance: button;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    touch-action: manipulation;
    line-height: 1.42857143;
    user-select: none;
    cursor: pointer;
  }

  .chartwatchers-signup-form-submit-button:hover,
  .chartwatchers-signup-form-submit-button:active,
  .chartwatchers-signup-form-submit-button:focus {
    background-color: #26a65b;
    border-color: #26a65b;
  }

  .chartwatchers-signup-form-success-message,
  .chartwatchers-signup-form-error-message {
    display: none;
  }

  .chartwatchers-signup-form-bot-signup {
    position: absolute;
    left: -5000px;
  }

  .chartwatchers-signup-learn-more-link-container {
    margin: 10px 0px 0px 0px;
    text-align: right;
    font-size: 14px;
  }

  .chartwatchers-signup-learn-more-link {
    color: #707f8f;
    transition: all 0.35s ease;
    text-decoration: none;
    background-color: transparent;
  }

  .chartwatchers-signup-learn-more-link:hover,
  .chartwatchers-signup-learn-more-link:active,
  .chartwatchers-signup-learn-more-link:focus {
    font-weight: 700;
  }

  .footer-lower-content {
    padding: 0px 15px;
    margin: 0px auto;
  }

  .site-links {
    padding: 0px 0px 15px 0px;
  }

  .site-link-group {
    width: 100%;
    display: inline-block;
    vertical-align: top;
    position: relative;
    min-height: 1px;
    padding: 0px 15px;
  }

  .site-link-group h4 {
    margin: 15px 0px 5px 0px;
    padding: 0px 0px 5px 0px;
    border-bottom: 1px solid #2c3a49;
    text-transform: uppercase;
    font-family: 'Roboto Condensed', 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 18px;
    font-weight: 900;
    color: #707f8f;
    line-height: 1.1;
  }

  .list-unstyled {
    padding: 0px;
    list-style: none;
    margin: 0px 0px 10px 0px;
  }

  .list-inline {
    padding: 0px;
    list-style: none;
    margin-left: -5px;
  }

  .site-link-group a {
    line-height: 1.70;
    font-size: 16px;
    font-weight: normal;
    color: #a9b2bc;
    transition: all 0.35s ease;
    text-decoration: none;
  }

  .site-link-group a:hover,
  .site-link-group a:active,
  .site-link-group a:focus {
    font-weight: 700;
    color: white;
  }

  .logo-column {
    position: relative;
    min-height: 1px;
    padding: 0px 15px;
  }

  .logo-link {
    transition: all 0.35s ease;
    color: #0f4d8a;
    text-decoration: none;
  }

  .logo-link img {
    width: 100%;
    max-width: 200px;
    display: inline-block;
    vertical-align: middle;
    border: 0;
  }

  .social-links {
    float: right;
    margin: 0px;
  }

  .social-links li {
    padding: 0px 16px;
    display: inline-block;
  }

  .social-links li:first-child {
    padding-left: 0px;
  }

  .social-links li:last-child {
    padding-right: 0px;
  }

  .social-links li a {
    font-size: 30px;
    color: #707f8f;
    transition: all 0.35s ease;
    text-decoration: none;
  }

  .social-links li a:hover,
  .social-links li a:active,
  .social-links li a:focus {
    color: white;
  }

  .copyright-and-mobile-app-buttons-column {
    margin: 10px 0px 30px 0px;
    padding: 15px 15px 0px 15px;
    border-width: 3px 0px 0px 0px;
    border-style: solid;
    border-color: #2c3a49;
    font-size: 14px;
    position: relative;
    min-height: 1px;
  }

  .mobile-app-buttons {
    display: inline-block;
    margin: 0px;
  }

  .mobile-app-buttons a {
    background-color: transparent;
    display: inline-block;
    margin: 0px 5px 0px 0px;
    line-height: 1.42857143;
    transition: all 0.35s ease;
  }

  .mobile-app-buttons a.mobile-app-button-for-larger-screen-widths {
    display: none;
  }

  .mobile-app-buttons a.mobile-app-button-for-smaller-screen-widths {
    display: inline-block;
  }

  .mobile-app-buttons a img {
    max-width: 145px;
    vertical-align: middle;
  }

  .copyright-content {
    float: right;
    margin: 0px;
  }

  .copyright {
    display: block;
    text-align: center;
    margin: 0px 0px 5px 0px;
    font-weight: normal;
    color: #707f8f;
    line-height: 1.75;
  }

  .copyright-links li {
    padding: 0px 10px;
    border-left: 1px solid #2c3a49;
    display: inline-block;
  }

  .copyright-links li:first-child {
    padding-left: 0px;
    border-left: 0;
  }

  .copyright-links li:last-child {
    padding-right: 0px;
  }

  .copyright-links li a {
    color: #707f8f;
    transition: all 0.35s ease;
    text-decoration: none;
  }

  .copyright-links li a:hover,
  .copyright-links li a:active,
  .copyright-links li a:focus {
    color: #a9b2bc;
  }

  .legal-column {
    padding: 0px 15px;
    text-align: center;
    position: relative;
    min-height: 1px;
  }

  .legal-column p {
    max-width: 1060px;
    margin: 0px auto;
    font-size: 12px;
    font-weight: normal;
    color: #5a6672;
  }

  @media (min-width: 767px) {
    .footer-upper-content,
    .footer-lower-content {
      width: 750px;
    }

    .site-link-group {
      width: 50%;
    }
  }

  @media (min-width: 992px) {
    .footer-upper-content,
    .footer-lower-content {
      width: 970px;
    }

    .chartwatchers-description {
      width: 58.33333333%;
      display: inline-block;
    }

    .chartwatchers-signup {
      width: 41.66666667%;
      display: inline-block;
    }

    .site-link-group {
      width: 25%;
    }

    .mobile-app-buttons a.mobile-app-button-for-larger-screen-widths {
      display: inline-block;
    }

    .mobile-app-buttons a.mobile-app-button-for-smaller-screen-widths {
      display: none;
    }
  }

  @media (min-width: 1200px) {
    .footer-upper-content,
    .footer-lower-content {
      width: 1170px;
    }

    .chartwatchers-description {
      width: 50%;
      display: inline-block;
    }

    .chartwatchers-signup {
      width: 50%;
      display: inline-block;
    }

    .legal-column {
      margin-left: 8.33333333%;
      width: 83.33333333%;
    }
  }

  @media (max-width: 767px) {
    .chartwatchers-background {
      top: 0;
      left: -50%;
      width: 100%;
      height: 100%;
    }

    .chartwatchers-description-heading {
      max-width: 300px;
      font-size: 22px;
    }

    .logo-link img {
      display: block;
      margin: 0px auto;
    }

    .social-links {
      float: none;
      display: block;
      margin: 15px auto 0px auto;
      text-align: center;
    }

    .copyright-and-mobile-app-buttons-column {
      margin-bottom: 15px;
      text-align: center;
    }

    .mobile-app-buttons {
      display: block;
    }

    .mobile-app-buttons a img {
      max-width: 125px;
    }

    .copyright-content {
      float: none;
      margin: 15px auto 0px auto;
      text-align: center;
    }

    .copyright-links li {
      display: block;
      padding: 0px 5px;
      border: 0;
    }

    .copyright-links li a {
      line-height: 1.75;
    }
  }
</style>
